/* VEILBORN — interactions */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---------- Cinematic hero reveal ---------- */
  function markLoaded() { requestAnimationFrame(function () { root.classList.add('is-loaded'); }); }
  if (document.readyState === 'complete') markLoaded();
  else window.addEventListener('load', markLoaded);
  setTimeout(markLoaded, 1800);

  /* ---------- Header ---------- */
  var header = document.querySelector('[data-vb-header]');
  var lastY = window.scrollY;
  function onScrollHeader() {
    if (!header) return;
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 40);
    if (!document.body.classList.contains('vb-nav-open')) {
      header.classList.toggle('is-hidden', y > lastY && y > 400);
    }
    lastY = y;
  }

  /* ---------- Mobile menu ---------- */
  var burger = document.querySelector('[data-vb-burger]');
  var nav = document.getElementById('vb-nav');
  function closeNav() {
    if (!burger || !nav) return;
    burger.setAttribute('aria-expanded', 'false');
    nav.classList.remove('is-open');
    document.body.classList.remove('vb-nav-open');
  }
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') !== 'true';
      burger.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('vb-nav-open', open);
      if (header) header.classList.remove('is-hidden');
    });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) closeNav(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  }

  /* ---------- Parallax ---------- */
  var heroMedia = document.querySelector('[data-vb-parallax]');
  var soft = Array.prototype.slice.call(document.querySelectorAll('[data-vb-parallax-soft]'));
  var ticking = false;
  function parallax() {
    ticking = false;
    var vh = window.innerHeight;
    if (heroMedia) {
      var y = window.scrollY;
      if (y < vh * 1.2) heroMedia.style.transform = 'translate3d(0,' + (y * 0.28).toFixed(1) + 'px,0)';
    }
    soft.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var progress = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (progress * -40).toFixed(1) + 'px,0)';
    });
  }
  function onScroll() {
    onScrollHeader();
    if (!reduceMotion && !ticking) { ticking = true; requestAnimationFrame(parallax); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Scroll reveal ---------- */
  var reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-vb-viewer]').forEach(function (viewer) {
    var tabs = Array.prototype.slice.call(viewer.querySelectorAll('[data-view-target]'));
    var slides = Array.prototype.slice.call(viewer.querySelectorAll('[data-view]'));
    var counter = viewer.querySelector('[data-view-current]');
    var idx = 0;
    function go(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
      tabs.forEach(function (t, j) {
        var on = j === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
          t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
      if (counter) counter.textContent = idx + 1;
    }
    tabs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    viewer.querySelectorAll('[data-view-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(idx + parseInt(b.getAttribute('data-view-step'), 10)); });
    });
    var stage = viewer.querySelector('.vb-viewer__stage');
    var sx = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }
  });

  /* ---------- Early interest form ---------- */
  var form = document.getElementById('vb-interest-form');
  if (form) {
    var tagsInput = form.querySelector('[data-vb-tags]');
    var submit = form.querySelector('[data-vb-submit]');
    var clean = function (v) { return String(v || '').replace(/[,]/g, ' ').replace(/\s+/g, ' ').trim(); };
    var setInvalid = function (field, invalid) { if (field) field.classList.toggle('is-invalid', invalid); };
    var validate = function () {
      var ok = true;
      var email = form.querySelector('input[type="email"]');
      var emailOk = email && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim());
      setInvalid(email && email.closest('.vb-field'), !emailOk);
      if (!emailOk) ok = false;
      ['vb_interest', 'vb_size'].forEach(function (name) {
        var checked = form.querySelector('input[name="' + name + '"]:checked');
        var fieldset = form.querySelector('input[name="' + name + '"]');
        setInvalid(fieldset && fieldset.closest('.vb-field'), !checked);
        if (!checked) ok = false;
      });
      var consent = form.querySelector('input[name="vb_consent"]');
      setInvalid(consent && consent.closest('.vb-field'), !consent.checked);
      if (!consent.checked) ok = false;
      return ok;
    };
    form.addEventListener('change', function (e) {
      var field = e.target.closest('.vb-field');
      if (field && field.classList.contains('is-invalid')) validate();
    });
    form.addEventListener('submit', function (e) {
      if (!validate()) {
        e.preventDefault();
        var first = form.querySelector('.is-invalid input, .is-invalid select');
        if (first) first.focus({ preventScroll: false });
        return;
      }
      var interest = form.querySelector('input[name="vb_interest"]:checked');
      var size = form.querySelector('input[name="vb_size"]:checked');
      var price = form.querySelector('select[name="vb_price"]');
      var tags = [tagsInput.getAttribute('data-base-tag')];
      if (interest) tags.push('VB interest: ' + clean(interest.value));
      if (size) tags.push('VB size: ' + clean(size.value));
      if (price && price.value) tags.push('VB price: ' + clean(price.value));
      tagsInput.value = tags.join(', ');
      if (submit) { submit.classList.add('is-loading'); submit.setAttribute('aria-busy', 'true'); }
    });
  }

  /* After a successful submission Shopify reloads the page — bring the visitor back to the message */
  var success = document.querySelector('[data-vb-success]');
  if (success || /customer_posted=true/.test(window.location.search)) {
    var join = document.getElementById('join');
    if (join) {
      setTimeout(function () {
        join.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (success) success.focus({ preventScroll: true });
      }, 300);
    }
  }
})();